import { handleActions } from 'redux-actions';
import * as ActionCreators from '../actionCreators/mesh';

const defaultState = {
  meshIOs: [],
};

const meshReducer = handleActions(
  {
    [ActionCreators.getMeshList]: (state, { payload }) => {
      return {
        ...state,
        meshIOs: (payload || [])?.map(m => {
          let toReturn = { ...m }
          toReturn["formattedFunction"] = toReturn.function === 'firepanels' ? 'Fire Integration' : toReturn.function === 'none' ? 'Repeater' : toReturn.function;

          return toReturn;
        }),
      };
    },
  },
  defaultState,
);

export default meshReducer;
